export var READ_ACTION_TYPES;
(function (READ_ACTION_TYPES) {
    READ_ACTION_TYPES["RESET_PERISCOPE"] = "reset_periscope";
    READ_ACTION_TYPES["RESET_ANALYSIS_PERISCOPE"] = "reset_analysis_periscope";
})(READ_ACTION_TYPES || (READ_ACTION_TYPES = {}));
